import React, { useEffect, useState } from "react";
import LinkInBio from "@/components/generated/LinkInBio";
import { Calendar, Instagram, Globe } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";
import { getCurrentUser } from "@/utils/authUtils";

export default function MagicPathLinkInBioPage() {
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchProfileLinks() {
      setLoading(true);
      const user = await getCurrentUser();
      if (!user) {
        setLoading(false);
        return;
      }
      const { data: profile } = await supabase
        .from("business_profiles")
        .select("booking_url, website, instagram")
        .eq("user_id", user.id)
        .single();
      if (!profile) {
        setLoading(false);
        return;
      }
      const dynamicLinks = [
        profile.booking_url && {
          id: "book",
          title: "Book an Appointment",
          url: profile.booking_url,
          icon: <Calendar className="h-4 w-4" />,
          isExternal: false,
        },
        profile.website && {
          id: "website",
          title: "Visit My Website",
          url: profile.website,
          icon: <Globe className="h-4 w-4" />,
          isExternal: true,
        },
        profile.instagram && {
          id: "instagram",
          title: "Instagram",
          url: profile.instagram,
          icon: <Instagram className="h-4 w-4" />,
          isExternal: true,
        },
      ].filter(Boolean);
      setLinks(dynamicLinks);
      setLoading(false);
    }
    fetchProfileLinks();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  return <LinkInBio links={links} />;
}

// To fully implement: When the user sets up their profile, prompt them to add these links.
// If a link is left blank, do not include it in the LinkInBio page (as above). 